import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import ChildTabViewModel from "./../../factories/child-tab-view-model";
import ConfigurationItemAuditDialog from "./../../factories/configuration-item-audit-dialog";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-number-box";
import "./../../bindings/bao-pager";
import "./../../bindings/bao-upload";
function ConfigurationItemAccountAssignmentTabModel(tabPage, parent) {
    var self = this;
    ChildTabViewModel.call(self, tabPage);
    self.Bao = Bao;
    self.ConfigurationItem = parent;
    self.CompleteCheck = function () {
        return true;
    };
    self.RefreshInProgress = ko.observable(false);
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.RefreshGrid();
    });
    self.PageSize = ko.observable(10);
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Sorting.subscribe(function () {
        self.RefreshGrid();
    });
    self.AccountAssignmentCollection = ko.observableArray([]);
    self.SelectAccountAssignmentRow = function (item) {
        self.SelectedAccountAssignmentRow(item);
        return true;
    };
    self.SelectedAccountAssignmentRow = ko.observable({});
    self.SelectedAccountAssignmentRow.subscribe(function () {
        if (self.SelectedAccountAssignmentRow() == null) {
            self.enableDisableButton("EditConfigurationItemAccountAssignment", false);
            self.enableDisableButton("DeleteConfigurationItemAccountAssignment", false);
        }
        else {
            self.enableDisableButton("EditConfigurationItemAccountAssignment", true);
            self.enableDisableButton("DeleteConfigurationItemAccountAssignment", true);
        }
    });
    var _deleteMessage = Bao.Session.GetMessage("msgDeleteConfigurationItemAccountAssignment");
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "AddConfigurationItemAccountAssignment":
                self.ShowConfigurationItemAccountAssignmentDialog(self.ConfigurationItem.ConfigurationItemId(), null);
                break;
            case "EditConfigurationItemAccountAssignment":
                if (self.SelectedAccountAssignmentRow() != null) {
                    self.EditConfigurationItemAccountAssignment(self.SelectedAccountAssignmentRow());
                }
                break;
            case "DeleteConfigurationItemAccountAssignment":
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessage, "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result === true) {
                        self.DeleteConfigurationItemAccountAssignment(self.ConfigurationItem.ConfigurationItemId(), self.SelectedAccountAssignmentRow().ConfigurationItem200AccountAssignmentId);
                    }
                });
                break;
            case "ConfigurationItemAccountAssignmentTabAudit":
                self.AuditTrail();
                break;
        }
    };
    self.GetFirstSelectedId = function () {
        if (ko.unwrap(self.SelectedAccountAssignmentRow()) != null) {
            return ko.unwrap(self.SelectedAccountAssignmentRow().PrimaryKeyValue);
        }
        return null;
    };
    self.UrlAuditTrail = "ConfigurationItemTab/CreateAuditTrailAccountAssignment";
    self.UrlAuditTrailOverview = "ConfigurationItemTab/CreateAuditTrailOverviewAccountAssignment";
    self.AuditTrail = function () {
        var auditDialog = null;
        if (self.GetFirstSelectedId() !== null) {
            auditDialog = new ConfigurationItemAuditDialog(self.GetFirstSelectedId(), ko.unwrap(tabPage.Title), tabPage, self.UrlAuditTrail);
        }
        else {
            auditDialog = new ConfigurationItemAuditDialog(self.ConfigurationItem.ConfigurationItemId(), ko.unwrap(tabPage.Title), tabPage, self.UrlAuditTrailOverview, true);
        }
        auditDialog.Open();
    };
    self.RefreshGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/GetConfigurationItem200AccountAssignmentCollection", JSON.stringify({
            sessionTabId: self.ConfigurationItem.TabPage.SessionTabId,
            configurationItemId: self.ConfigurationItem.ConfigurationItemId(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedAccountAssignmentRow(null);
            self.TotalRows(0);
            self.AccountAssignmentCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.AccountAssignmentCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
        });
    };
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    self.AddConfigurationItemAccountAssignment = function (model, configurationItemId) {
        tabPage.IsLoading(true);
        Bao.post("ConfigurationItemTab/AddConfigurationItem200AccountAssignment", JSON.stringify({
            sessionTabId: self.ConfigurationItem.TabPage.SessionTabId,
            configurationItem200AccountAssignmentModel: ko.map.toJS(model, true),
            configurationItemId: configurationItemId
        }), function (result) {
            if (result.Result == true) {
                self.ConfigurationItem.TabPage.DirtyFlag(true);
                self.RefreshGrid();
            }
            else {
                new BaoDialogViewModel(Bao.Session.ApplicationName, result.Message, "info");
                self.RefreshGrid();
            }
        });
    };
    self.DeleteConfigurationItemAccountAssignment = function (configurationItemId, configurationItem200AccountAssignmentId) {
        self.RefreshInProgress(true);
        Bao.post("ConfigurationItemTab/DeleteConfigurationItem200AccountAssignment", JSON.stringify({
            sessionTabId: self.ConfigurationItem.TabPage.SessionTabId,
            configurationItemId: configurationItemId,
            configurationItem200AccountAssigmentId: configurationItem200AccountAssignmentId
        }), function () {
            self.RefreshInProgress(false);
            self.ConfigurationItem.TabPage.DirtyFlag(true);
            self.RefreshGrid();
        });
    };
    self.EditConfigurationItemAccountAssignment = function (item) {
        self.ShowConfigurationItemAccountAssignmentDialog(self.ConfigurationItem.ConfigurationItemId(), item.ConfigurationItem200AccountAssignmentId);
    };
    self.ShowConfigurationItemAccountAssignmentDialog = function (configurationItemId, configurationItem200AccountAssignmentId) {
        window.baorequire(["ViewModels/Dialogs/ConfigurationItemAccountAssignmentDialog"], function (vm) {
            var dialog = new vm(tabPage, self);
            dialog.Show(configurationItemId, configurationItem200AccountAssignmentId);
            dialog.DialogResult.subscribe(function (dialogResult) {
                if (dialogResult == "ok") {
                    self.AddConfigurationItemAccountAssignment(dialog.DialogViewModel, self.ConfigurationItem.ConfigurationItemId());
                }
            });
        });
    };
    self.enableDisableButton = function (actionKey, enabled) { };
    self.Refresh = function () {
        var def = $.Deferred();
        Bao.post("ConfigurationItemTab/ResetConfigurationItem200AccountAssignment", JSON.stringify({
            sessionTabId: self.ConfigurationItem.TabPage.SessionTabId
        }), function () {
            self.RefreshGrid().then(function () {
                def.resolve();
            });
        });
        return def.promise();
    };
    self.Save = function () {
        return Bao.post("ConfigurationItemTab/SaveConfigurationItem200AccountAssignmentCollection", JSON.stringify({
            sessionTabId: self.ConfigurationItem.TabPage.SessionTabId,
            configurationItemId: self.ConfigurationItem.ConfigurationItemId(),
            saveTime: parent.SaveTime()
        }));
    };
    self.loaded = function () {
        return self.Refresh();
    };
}
;
Bao.inherit(ConfigurationItemAccountAssignmentTabModel, ChildTabViewModel);
export default ConfigurationItemAccountAssignmentTabModel;